import { GET_ALL_PAUSAS, GET_SPECIFIC_PAUSA } from './mutation-types'
import pausaHttpService from '../_services/pausaHttpService'

export default {
  listarPausas: async ({ commit }) => {
    try {
      const response = await pausaHttpService.getPausas()
      commit(GET_ALL_PAUSAS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarPausaEspecifica: async ({ commit }, id) => {
    try {
      const response = await pausaHttpService.getPausa(id)
      commit(GET_SPECIFIC_PAUSA, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
